import { jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { ResourcePreviewFolder } from './ResourcePreviewFolder.js';
import { ResourcePreviewHighlight } from './ResourcePreviewHighlight.js';
import { ResourcePreviewImageBookmark } from './ResourcePreviewImageBookmark.js';
import { ResourcePreviewNotepad } from './ResourcePreviewNotepad.js';
import { ResourcePreviewPage } from './ResourcePreviewPage.js';
import { ResourcePreviewFile } from './ResourcePreviewStoredFile.js';
import { isResourceDetailImageBookmark, isResourceDetailBookmark, isResourceDetailHighlight, isResourceDetailFolder, isResourceDetailNotepad, isResourceDetailEmail } from '../../../../utils/resourceDetailGuards.js';
import { createLogger } from '@fabric-app/utils/logging';
import { ResourcePreviewEmail } from './ResourcePreviewEmail.js';

const logger = createLogger("ResourcePreviewContent");
const ResourcePreviewContent = () => {
  const { resource } = useResourceDataContextSafe();
  if (isResourceDetailImageBookmark(resource)) {
    return /* @__PURE__ */ jsx(ResourcePreviewImageBookmark, {});
  }
  if (isResourceDetailBookmark(resource)) {
    return /* @__PURE__ */ jsx(ResourcePreviewPage, {});
  }
  if (isResourceDetailHighlight(resource)) {
    return /* @__PURE__ */ jsx(ResourcePreviewHighlight, {});
  }
  if (isResourceDetailFolder(resource)) {
    return /* @__PURE__ */ jsx(ResourcePreviewFolder, {});
  }
  if (isResourceDetailNotepad(resource)) {
    return /* @__PURE__ */ jsx(ResourcePreviewNotepad, {});
  }
  if (isResourceDetailEmail(resource)) {
    return /* @__PURE__ */ jsx(ResourcePreviewEmail, {});
  }
  if (resource.fileUrl) {
    return /* @__PURE__ */ jsx(ResourcePreviewFile, {});
  }
  logger.error("Unhandled render", resource);
  return null;
};

export { ResourcePreviewContent };
//# sourceMappingURL=ResourcePreviewContent.js.map
